import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ab43f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "d-none d-lg-block" }
const _hoisted_3 = { class: "d-block d-lg-none" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-4 text-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col col-md-4 border-bottom" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Mon Inscription")
  ])
], -1))
const _hoisted_6 = { class: "row m-2 mt-3 text-start" }
const _hoisted_7 = { class: "col-12 mx-2" }
const _hoisted_8 = {
  key: 0,
  class: "row m-2 mt-3"
}
const _hoisted_9 = { class: "col-12 col-md-3" }
const _hoisted_10 = { class: "container-fluid bg-light p-1 pt-3 pb-3 me-md-2 m-2 rounded-3 shadow-sm" }
const _hoisted_11 = { class: "row pt-1" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Statut de mon inscription", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "big-emoji pb-0 mb-0 pt-3"
}
const _hoisted_16 = {
  key: 1,
  class: "big-emoji pb-0 mb-0 pt-3"
}
const _hoisted_17 = {
  key: 2,
  class: "big-emoji pb-0 mb-0 pt-3"
}
const _hoisted_18 = { class: "row pt-1 text-center" }
const _hoisted_19 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_20 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_21 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_22 = { class: "col-12 col-md-3" }
const _hoisted_23 = { class: "container-fluid bg-light p-1 pt-3 pb-3 me-md-2 m-2 rounded-3 shadow-sm" }
const _hoisted_24 = { class: "row pt-1 pb-1" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Mon Document Médical", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_28 = {
  key: 1,
  class: "big-emoji pb-0 mb-0 pt-3"
}
const _hoisted_29 = {
  key: 2,
  class: "big-emoji pb-0 mb-0 pt-3"
}
const _hoisted_30 = { class: "row pt-1 text-center" }
const _hoisted_31 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_32 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_33 = { class: "col-12 col-md-3" }
const _hoisted_34 = { class: "container-fluid bg-light p-1 pt-3 pb-3 me-md-2 m-2 rounded-3 shadow-sm" }
const _hoisted_35 = { class: "row pt-1 pb-1" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Ma Carte VAvantages", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_39 = {
  key: 0,
  class: "big-emoji pb-0 mb-0 pt-3"
}
const _hoisted_40 = { class: "row pt-1 text-center" }
const _hoisted_41 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_42 = { class: "col-12 col-md-3" }
const _hoisted_43 = { class: "container-fluid bg-light p-1 pt-3 pb-3 me-md-2 m-2 rounded-3 shadow-sm" }
const _hoisted_44 = { class: "row pt-1 pb-1" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Mon Paiement", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_48 = {
  key: 2,
  class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji"
}
const _hoisted_49 = {
  key: 4,
  class: "big-emoji pb-0 mb-0 pt-3"
}
const _hoisted_50 = {
  key: 5,
  class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji"
}
const _hoisted_51 = { class: "row pt-1 text-center" }
const _hoisted_52 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_53 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_54 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_55 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_56 = {
  key: 4,
  class: "mb-0"
}
const _hoisted_57 = {
  key: 5,
  class: "mb-0"
}
const _hoisted_58 = {
  key: 1,
  class: "row ms-3"
}
const _hoisted_59 = {
  key: 1,
  class: "col-8 p-2 bg-primary rounded text-light text-center d-flex align-items-center"
}
const _hoisted_60 = { class: "p-1" }
const _hoisted_61 = { class: "ps-1" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-4 text-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col col-md-4 border-bottom" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Mon Équipe")
  ])
], -1))
const _hoisted_63 = { class: "row m-2 mt-3 text-start" }
const _hoisted_64 = { class: "col-12 mx-2" }
const _hoisted_65 = {
  key: 0,
  class: "col-12 bg-primary rounded text-light text-start pt-2"
}
const _hoisted_66 = ["href"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("u", null, "Attention:")
], -1))
const _hoisted_68 = ["href"]
const _hoisted_69 = {
  key: 1,
  class: "col-12 bg-primary rounded text-light text-start pt-2"
}
const _hoisted_70 = ["href"]
const _hoisted_71 = { class: "row mx-3 mt-3" }
const _hoisted_72 = { class: "col col-md-3 border-bottom text-start vertical-center-container" }
const _hoisted_73 = { class: "vertical-center" }
const _hoisted_74 = { class: "row mx-3" }
const _hoisted_75 = { class: "col mx-2 bg-light rounded-bottom shadow-sm" }
const _hoisted_76 = { class: "row fw-bold text-start" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-danger" }, " Les deux mots de passe ne correspondent pas! ", -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "row fw-bold text-start" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-success" }, " Mise à jour du mot de passe réussie 🎉 ", -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "row fw-bold text-start" }
const _hoisted_83 = { class: "col-12 my-2 col-md-5 form-groups" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputNewTeamPassword" }, "Nouveau mot de passe: ", -1))
const _hoisted_85 = { class: "col-12 my-2 col-md-5 form-groups" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputConfirmTeamPassword" }, "Confirmez mot de passe: ", -1))
const _hoisted_87 = { class: "col-12 my-2 col-md form-groups text-center btn-container" }
const _hoisted_88 = { class: "vertical-center-button" }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = { class: "d-sm-felx row mx-3 mt-3" }
const _hoisted_91 = { class: "col mx-2 bg-light rounded-3 shadow-sm" }
const _hoisted_92 = { class: "table table-striped table-hover w-100" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Responsable d'équipe", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Athlète", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Statut de l'inscription", -1))
const _hoisted_96 = { scope: "col" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { scope: "row" }
const _hoisted_99 = {
  key: 0,
  class: "material-icons-outlined"
}
const _hoisted_100 = {
  key: 0,
  class: "material-icons-outlined",
  style: {"color":"green"}
}
const _hoisted_101 = {
  key: 1,
  class: "material-icons-outlined",
  style: {"color":"red"}
}
const _hoisted_102 = ["onClick"]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "row m-2 mt-4 text-start" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-md-4 border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Mes Résultats")
], -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = { class: "row m-2 mt-4 text-start" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-md-4 border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Mes Paiements")
], -1))
const _hoisted_109 = { class: "d-sm-felx row mx-3 mt-3" }
const _hoisted_110 = { class: "col mx-2 bg-light rounded-3 shadow-sm" }
const _hoisted_111 = { class: "table table-striped table-hover w-100" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Édition"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Course"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Prix inscription"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Prix don"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Statut"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Reçu HelloAsso")
  ])
], -1))
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { key: 2 }
const _hoisted_116 = { key: 3 }
const _hoisted_117 = ["href"]
const _hoisted_118 = { class: "row m-2 mt-4 text-start" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-md-4 border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Mes Certificats")
], -1))
const _hoisted_120 = { class: "d-sm-felx row mx-3 mt-3" }
const _hoisted_121 = { class: "col mx-2 bg-light rounded-3 shadow-sm" }
const _hoisted_122 = { class: "table table-striped table-hover w-100" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Édition"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Fichier")
  ])
], -1))
const _hoisted_124 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_MiniTopBar = _resolveComponent("MiniTopBar")!
  const _component_CertificateModal = _resolveComponent("CertificateModal")!
  const _component_VaModal = _resolveComponent("VaModal")!
  const _component_PaymentModal = _resolveComponent("PaymentModal")!
  const _component_TeamAdminModal = _resolveComponent("TeamAdminModal")!
  const _component_DisplayCertificate = _resolveComponent("DisplayCertificate")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TopBar, {
          title: _ctx.title,
          userButton: true
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MiniTopBar, { userButton: true })
      ]),
      _withDirectives(_createVNode(_component_CertificateModal, {
        onCloseCertificateModal: _ctx.toggleCertificateModal,
        onOpenErrorModal: _ctx.toggleErrorModal
      }, null, 8, ["onCloseCertificateModal", "onOpenErrorModal"]), [
        [_vShow, _ctx.showCertificateModal]
      ]),
      _withDirectives(_createVNode(_component_VaModal, {
        onCloseVaModal: _ctx.toggleVaModal,
        onOpenErrorModal: _ctx.toggleErrorModal
      }, null, 8, ["onCloseVaModal", "onOpenErrorModal"]), [
        [_vShow, _ctx.showVaModal]
      ]),
      _withDirectives(_createVNode(_component_PaymentModal, { onClosePaymentModal: _ctx.togglePaymentModal }, null, 8, ["onClosePaymentModal"]), [
        [_vShow, _ctx.showPaymentModal]
      ]),
      _withDirectives(_createVNode(_component_TeamAdminModal, {
        onCloseTeamAdminModal: _ctx.toggleTeamAdminModal,
        onOpenErrorModal: _ctx.toggleErrorModal,
        onSuccess: _ctx.getTeamInfos,
        athlete: _ctx.athlete,
        actionType: _ctx.actionType,
        teamId: _ctx.team.id
      }, null, 8, ["onCloseTeamAdminModal", "onOpenErrorModal", "onSuccess", "athlete", "actionType", "teamId"]), [
        [_vShow, _ctx.showTeamAdminModal]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, [
              _createTextVNode(" Vous êtes inscrit dans la course: "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.inscription?.race?.name || "aucune"), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.race?.disciplines, (raceDiscipline) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "badge rounded-pill bg-secondary ms-1",
                  key: raceDiscipline.id
                }, _toDisplayString(raceDiscipline.discipline.name) + " (" + _toDisplayString(raceDiscipline.duration) + "h) ", 1))
              }), 128))
            ])
          ])
        ]),
        (_ctx.inscription?.race)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      (_ctx.inscription === undefined)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_15, " 😢 "))
                        : (
                    _ctx.inscription?.status === _ctx.InscriptionStatus.VALIDATED
                  )
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_16, " 🎉 "))
                          : (_ctx.inscription?.status === _ctx.InscriptionStatus.PENDING)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_17, " ⌛ "))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.inscription === undefined)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Inscription incomplète "))
                      : (_ctx.inscription?.status === _ctx.InscriptionStatus.VALIDATED)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Inscription complète "))
                        : (_ctx.inscription?.status === _ctx.InscriptionStatus.PENDING)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, " En cours de validation ... "))
                          : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      (_ctx.inscription?.certificate?.status === 5)
                        ? (_openBlock(), _createElementBlock("h5", {
                            key: 0,
                            class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCertificateModal && _ctx.toggleCertificateModal(...args)))
                          }, " 😱 "))
                        : _createCommentVNode("", true),
                      (_ctx.inscription?.certificate?.status === 1)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_28, " 🎉 "))
                        : _createCommentVNode("", true),
                      (_ctx.inscription?.certificate?.status === 4)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_29, " ⌛ "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.inscription?.certificate === undefined ||
                    _ctx.inscription?.certificate === null
                  )
                        ? (_openBlock(), _createElementBlock("h5", {
                            key: 3,
                            class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCertificateModal && _ctx.toggleCertificateModal(...args)))
                          }, " 🤔 "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.inscription?.certificate?.status === 5)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "mb-0",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleCertificateModal && _ctx.toggleCertificateModal(...args)))
                        }, " Document rejeté! "))
                      : _createCommentVNode("", true),
                    (_ctx.inscription?.certificate?.status === 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_31, " Document validé! "))
                      : _createCommentVNode("", true),
                    (_ctx.inscription?.certificate?.status === 4)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, " En cours de validation ... "))
                      : _createCommentVNode("", true),
                    (
                  _ctx.inscription?.certificate === undefined ||
                  _ctx.inscription?.certificate === null
                )
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 3,
                          class: "mb-0",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCertificateModal && _ctx.toggleCertificateModal(...args)))
                        }, " Document médical manquant! "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _hoisted_38,
                      (_ctx.inscription?.va)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_39, " 🎉 "))
                        : (_openBlock(), _createElementBlock("h5", {
                            key: 1,
                            class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleVaModal && _ctx.toggleVaModal(...args)))
                          }, " 🤔 "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    (_ctx.inscription?.va)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_41, " Carte VAvantages validée! "))
                      : (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: "mb-0",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleVaModal && _ctx.toggleVaModal(...args)))
                        }, " Pas de carte VAvantages! "))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _hoisted_47,
                      (
                    _ctx.inscription?.payment?.status ===
                      _ctx.PaymentStatus.NOT_STARTED || !_ctx.inscription?.payment
                  )
                        ? (_openBlock(), _createElementBlock("h5", {
                            key: 0,
                            class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.togglePaymentModal && _ctx.togglePaymentModal(...args)))
                          }, " 🤔 "))
                        : _createCommentVNode("", true),
                      (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.PENDING)
                        ? (_openBlock(), _createElementBlock("h5", {
                            key: 1,
                            class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.togglePaymentModal && _ctx.togglePaymentModal(...args)))
                          }, " ⌛ "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.inscription?.payment?.status === _ctx.PaymentStatus.VALIDATED
                  )
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_48, " 🎉 "))
                        : _createCommentVNode("", true),
                      (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.REFUSED)
                        ? (_openBlock(), _createElementBlock("h5", {
                            key: 3,
                            class: "big-emoji pb-0 mb-0 pt-3 hightlight-emoji",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.togglePaymentModal && _ctx.togglePaymentModal(...args)))
                          }, " 😢 "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.inscription?.payment?.status === _ctx.PaymentStatus.REFUNDING
                  )
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_49, " 🏦 "))
                        : _createCommentVNode("", true),
                      (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.REFUND)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_50, " 🤑 "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    (
                  _ctx.inscription?.payment?.status === _ctx.PaymentStatus.NOT_STARTED ||
                  !_ctx.inscription?.payment
                )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_52, " Paiement non initié "))
                      : _createCommentVNode("", true),
                    (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.PENDING)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, " Paiement en cours "))
                      : _createCommentVNode("", true),
                    (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.VALIDATED)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_54, " Paiement validé "))
                      : _createCommentVNode("", true),
                    (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.REFUSED)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_55, " Paiement refusé "))
                      : _createCommentVNode("", true),
                    (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.REFUNDING)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_56, " Remboursement en cours "))
                      : _createCommentVNode("", true),
                    (_ctx.inscription?.payment?.status === _ctx.PaymentStatus.REFUND)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_57, " Remboursé "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_58, [
              (_ctx.isRegistrationOpen)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "col-2 btn btn-primary",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.register()))
                  }, " S'inscrire "))
                : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createTextVNode(" La période pour s'inscrire commence le "),
                    _createElementVNode("strong", _hoisted_60, _toDisplayString(_ctx.getRegistrationStartDate), 1),
                    _createTextVNode(" et se termine le "),
                    _createElementVNode("strong", _hoisted_61, _toDisplayString(" "+_ctx.getRegistrationEndDate + " "), 1),
                    _createTextVNode(". ")
                  ]))
            ])),
        _hoisted_62,
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createTextVNode(" Vous êtes inscrit dans l'équipe: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.inscription?.team?.name || "aucune"), 1)
          ]),
          (_ctx.inscription?.team?.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("p", null, [
                  _createTextVNode(" Si vous souhaitez quitter l'équipe, merci de contacter l'équipe des courses à l'adresse "),
                  _createElementVNode("a", {
                    href: _ctx.mailURL()
                  }, "overrun@24heures.org", 8, _hoisted_66),
                  _createTextVNode(" en leur indiquant vos nom, prénom et nom d'équipe. Nous nous chargerons d'effectuer le remboursement de votre paiement le cas échéant avant de vous retirer de l'équipe. Vous pourrez ensuite choisir une nouvelle course et/ou équipe. ")
                ]),
                _withDirectives(_createElementVNode("p", null, [
                  _hoisted_67,
                  _createTextVNode(" si vous êtes le seul responsable d'équipe, il ne sera pas possible pour vous de quitter l'équipe. Si vous souhaitez retirer un membre de votre équipe, merci de contacter l'équipe des courses à l'adresse "),
                  _createElementVNode("a", {
                    href: _ctx.mailURL()
                  }, "overrun@24heures.org", 8, _hoisted_68),
                  _createTextVNode(" en leur indiquant son nom, prénom et nom d'équipe. Nous nous chargerons d'effectuer le remboursement de son paiement le cas échéant avant de le retirer de l'équipe. Il pourra ensuite choisir une nouvelle course et/ou équipe. ")
                ], 512), [
                  [_vShow, _ctx.isTeamAdmin(_ctx.me.id)]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createElementVNode("p", null, [
                  _createTextVNode(" Si vous souhaitez rejoindre une équipe, merci de contacter l'équipe des courses à l'adresse "),
                  _createElementVNode("a", {
                    href: _ctx.mailURL()
                  }, "overrun@24heures.org", 8, _hoisted_70),
                  _createTextVNode(" en leur indiquant vos nom et prénom. Nous nous chargerons d'effectuer le remboursement de votre paiement le cas échéant. Vous pourrez ensuite choisir une nouvelle course et/ou équipe. ")
                ])
              ]))
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("h6", null, [
                  _createTextVNode(" Paramètres équipe "),
                  _withDirectives(_createElementVNode("span", {
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleTeamSettings && _ctx.toggleTeamSettings(...args))),
                    class: "material-icons-outlined chevron"
                  }, " expand_more ", 512), [
                    [_vShow, _ctx.showTeamSettings]
                  ]),
                  _withDirectives(_createElementVNode("span", {
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleTeamSettings && _ctx.toggleTeamSettings(...args))),
                    class: "material-icons-outlined chevron"
                  }, " chevron_right ", 512), [
                    [_vShow, !_ctx.showTeamSettings]
                  ])
                ])
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _withDirectives(_createElementVNode("div", _hoisted_76, _hoisted_78, 512), [
                [_vShow, _ctx.newTeamPassword !== _ctx.confirmTeamPassword]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_79, _hoisted_81, 512), [
                [_vShow, _ctx.successPasswordUpdate]
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitChangeTeamPassword && _ctx.submitChangeTeamPassword(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newTeamPassword) = $event)),
                      id: "inputNewTeamPassword",
                      minlength: "8"
                    }, null, 512), [
                      [_vModelText, _ctx.newTeamPassword]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _hoisted_86,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.confirmTeamPassword) = $event)),
                      id: "inputConfirmPassword",
                      minlength: "8"
                    }, null, 512), [
                      [_vModelText, _ctx.confirmTeamPassword]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("button", {
                        class: "btn btn-primary m-auto align-middle",
                        disabled: 
                        _ctx.newTeamPassword === '' ||
                        _ctx.newTeamPassword !== _ctx.confirmTeamPassword
                      
                      }, " Mettre à jour ", 8, _hoisted_89)
                    ])
                  ])
                ])
              ], 32)
            ])
          ], 512), [
            [_vShow, _ctx.showTeamSettings]
          ])
        ], 512), [
          [_vShow, _ctx.isTeamAdmin(_ctx.me.id)]
        ]),
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _withDirectives(_createElementVNode("table", _hoisted_92, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_93,
                  _hoisted_94,
                  _hoisted_95,
                  _withDirectives(_createElementVNode("th", _hoisted_96, "Actions", 512), [
                    [_vShow, _ctx.isTeamAdmin(_ctx.me.id)]
                  ])
                ])
              ]),
              (_ctx.team.members)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_97, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembersWithoutCanceledInscription(), (member) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: member.id
                      }, [
                        _createElementVNode("th", _hoisted_98, [
                          (_ctx.isTeamAdmin(member.athlete.id))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_99, " military_tech "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(member.athlete.firstName) + " " + _toDisplayString(member.athlete.lastName), 1),
                        _createElementVNode("td", null, [
                          (member.status === _ctx.InscriptionStatus.VALIDATED)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_100, " check_circle "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_101, " cancel "))
                        ]),
                        _withDirectives(_createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("button", {
                            class: "btn btn-success mx-1",
                            title: "Ajoute l'athlète à la liste de responsables d'équipe",
                            onClick: ($event: any) => (
                      _ctx.openTeamAdminModal(
                        member.athlete,
                        _ctx.TeamAdminModalType.PROMOTE_ADMIN
                      )
                    )
                          }, " Promouvoir responsable d'équipe ", 8, _hoisted_102), [
                            [_vShow, !_ctx.isTeamAdmin(member.athlete.id)]
                          ]),
                          _withDirectives(_createElementVNode("button", {
                            class: "btn btn-danger mx-1",
                            title: "Supprime l'athlète de la liste de responsables d'équipe",
                            onClick: ($event: any) => (
                      _ctx.openTeamAdminModal(
                        member.athlete,
                        _ctx.TeamAdminModalType.REVOKE_ADMIN
                      )
                    )
                          }, " Retirer responsable d'équipe ", 8, _hoisted_103), [
                            [_vShow, 
                      _ctx.isTeamAdmin(member.athlete.id) &&
                      member.athlete.id !== _ctx.me.id
                    ]
                          ])
                        ], 512), [
                          [_vShow, _ctx.isTeamAdmin(_ctx.me.id)]
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.inscription?.team?.name]
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_104, _hoisted_106, 512), [
          [_vShow, false]
        ]),
        _createElementVNode("div", _hoisted_107, [
          _hoisted_108,
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("table", _hoisted_111, [
                _hoisted_112,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myInscriptionWithoutCanceledPayment(), (inscription) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: inscription.payment.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(inscription.edition?.name), 1),
                      _createElementVNode("td", null, _toDisplayString(inscription.race.name), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.centimesToEuros(inscription.payment.raceAmount)) + " € ", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.centimesToEuros(inscription.payment.donationAmount)) + " € ", 1),
                      (
                      inscription.payment?.status === _ctx.PaymentStatus.VALIDATED
                    )
                        ? (_openBlock(), _createElementBlock("td", _hoisted_113, " Validé "))
                        : (
                      inscription.payment.status === _ctx.PaymentStatus.REFUND
                    )
                          ? (_openBlock(), _createElementBlock("td", _hoisted_114, " Remboursé "))
                          : (
                      inscription.payment.status === _ctx.PaymentStatus.REFUNDING
                    )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_115, " En cours de remboursement "))
                            : (_openBlock(), _createElementBlock("td", _hoisted_116)),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: inscription.payment.helloassoPaymentReceiptUrl,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(inscription.payment?.helloassoPaymentReceiptUrl), 9, _hoisted_117)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_118, [
          _hoisted_119,
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("table", _hoisted_122, [
                _hoisted_123,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myInscriptionWithCertificate(), (inscription) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: inscription.certificate.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(inscription.edition?.name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (
                        _ctx.openCertificateModal(inscription.certificate.filename)
                      )
                        }, _toDisplayString(inscription.certificate.filename), 9, _hoisted_124)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_DisplayCertificate, {
      onCloseDisplayCertificateModal: _ctx.toggleDisplayCertificateModal,
      certificateFile: _ctx.certificateFile
    }, null, 8, ["onCloseDisplayCertificateModal", "certificateFile"]), [
      [_vShow, _ctx.showDisplayCertificateModal]
    ]),
    _withDirectives(_createVNode(_component_ConfirmModal, {
      onCloseConfirmModal: _ctx.toggleConfirmModal,
      onCallback: _ctx.confirmCallback,
      message: _ctx.confirmMessage
    }, null, 8, ["onCloseConfirmModal", "onCallback", "message"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _withDirectives(_createVNode(_component_ErrorModal, { onCloseErrorModal: _ctx.toggleErrorModal }, null, 8, ["onCloseErrorModal"]), [
      [_vShow, _ctx.showErrorModal]
    ]),
    _withDirectives(_createVNode(_component_SuccessModal, {
      onCloseSuccessModal: _ctx.toggleSuccessModal,
      message: _ctx.successMessage
    }, null, 8, ["onCloseSuccessModal", "message"]), [
      [_vShow, _ctx.showSuccessModal]
    ])
  ], 64))
}